/// \file customersRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";
import customerView from "./customerView";
const CustomersList = lazy(() => import('../views/customers/list/view'));

async function customersDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/customers/list/loader')).default;
  return actualLoader(args);
}

export async function customersAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/customers/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="customers"
    handle={{
      text: 'Customers'
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <CustomersList />
        </Suspense>
      }
      loader={customersDataLoader}
      action={customersAction}     
    />
    {customerView}
  </Route>
);

export default routes;